// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.answer-holder{
    width: 90%;
    display: flex;
    flex-direction: column;
    margin: 3px 0 3px 5px;
    border-bottom: #b2bec3 1px solid;
}

.answer-holder__header{
    display: flex;
    flex-direction: row;
}

.answer-holder__link{
    margin-right: 6px;
    cursor: pointer;
}

.answer-holder__body {
    text-align: left;
}

p {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-widget/answer-message-body/answer-holder/AnswerHolder.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC","sourcesContent":[".answer-holder{\r\n    width: 90%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 3px 0 3px 5px;\r\n    border-bottom: #b2bec3 1px solid;\r\n}\r\n\r\n.answer-holder__header{\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.answer-holder__link{\r\n    margin-right: 6px;\r\n    cursor: pointer;\r\n}\r\n\r\n.answer-holder__body {\r\n    text-align: left;\r\n}\r\n\r\np {\r\n    margin-top: 0px !important;\r\n    margin-bottom: 0px !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
